import React, { useState } from 'react';
import './App.css';
import AudioPlayer from './components/AudioPlayer';
import PomodoroTimer from './components/PomodoroTimer';

function App() {
  const [pomodoroMode, setPomodoroMode] = useState<string>('focus');
  
  const [linkWithWhiteNoise, setLinkWithWhiteNoise] = useState<boolean>(true);
  
  const handlePomodoroModeChange = (mode: string, linkNoise?: boolean) => {
    setPomodoroMode(mode);
    if (linkNoise !== undefined) {
      setLinkWithWhiteNoise(linkNoise);
    }
  };
  
  return (
    <div className="min-h-screen bg-gray-900 flex flex-col items-center justify-start text-white p-4 space-y-8 py-10">
      <PomodoroTimer onModeChange={handlePomodoroModeChange} />
      <AudioPlayer pomodoroMode={pomodoroMode} linkWithWhiteNoise={linkWithWhiteNoise} />
    </div>
  );
}

export default App;